import styled from 'styled-components';

const NewsletterContent = styled.div`
  text-align: center;
  padding: 6rem 0;
  @media (min-width: 498px) {
    padding: 3rem 0;
  }
  @media (min-width: 768px) {
    padding: 0;
  }
`;

export default NewsletterContent;
